module.exports = __webpack_public_path__ + "img/qrcode-img.ea5bdb93.png";